<template>
  <v-app id="inspire">
    <v-navigation-drawer
      v-if="check.path !== '/' && check.matched[0].path !== '/preview/:id'"
      v-model="drawer"
      :clipped="$vuetify.breakpoint.lgAndUp"
      app
    >
      <AppDrawer />
    </v-navigation-drawer>

    <v-app-bar
      dense
      v-if="check.path !== '/' && check.matched[0].path !== '/preview/:id'"
      :clipped-left="$vuetify.breakpoint.lgAndUp"
      app
      style="z-index:100"
      color="white"
      elevation="5"
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
      <v-toolbar-title style="width: 300px" class="ml-0 pl-4">
        <span>Klik Lelang Admin</span>
      </v-toolbar-title>
      <v-spacer />
      <v-btn icon>
        <v-icon>mdi-apps</v-icon>
      </v-btn>
      <v-btn icon>
        <v-icon>mdi-bell</v-icon>
      </v-btn>
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn icon large v-on="on">
            <v-avatar size="32px" item>
              <v-img src="/img/profile.png" />
            </v-avatar>
          </v-btn>
        </template>
        <v-list>
          <v-list-item
            v-for="(item, index) in items"
            :key="index"
            @click="OnLogout"
          >
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
    <v-content>
      <div class="pa-5">
        <router-view></router-view>
      </div>
    </v-content>
  </v-app>
</template>

<script>
import AppDrawer from './components/AppDrawer';
export default {
  props: {
    source: String
  },
  components: {
    AppDrawer
  },
  data: () => ({
    dialog: false,
    drawer: null,
    items: [{ icon: 'mdi-logout', title: 'Logout', to: '/' }]
  }),
  methods: {
    OnLogout() {
      // console.log('logus');
      localStorage.removeItem('user');
      localStorage.removeItem('token');

      this.$store.commit('SET_USER', []);
      this.$store.commit('SET_TOKEN', []);
      // this.$router.push({ path: '/' });
      this.$router.go();
    }
  },
  computed: {
    check() {
      console.log(this.$route);
      return this.$route;
    }
  },
  mounted() {}
};
</script>
<style>
::-webkit-scrollbar {
  width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 3px grey;
  border-radius: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: grey;
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #c90000;
}
.lokasiHover:hover {
  background: #ffeeee;
}
</style>
